import React from "react";
import { Box } from "@mui/material";
import "./TalentAuthLayout.css";

export default function TalentAuthLayout({ children, imageUrl, imagePosition = "center center" }) {
  return (
    <Box className="talent-auth-shell">
      <Box className="talent-auth-panel">
        <Box className="talent-auth-form-side">
          <Box className="talent-auth-form-card">{children}</Box>
        </Box>
        {imageUrl ? (
          <Box className="talent-auth-image-side" aria-hidden="true">
            <img src={imageUrl} alt="" loading="eager" style={{ objectPosition: imagePosition }} />
          </Box>
        ) : null}
      </Box>
    </Box>
  );
}
